import { TableRow } from "../data";

function RouteDurationCell({
  data,
  value,
}: {
  data: TableRow;
  value?: string;
}) {
  if (!data || data.entity !== "route") {
    return "";
  }

  // @ts-ignore - routeDuration is added to route rows
  const duration = data.routeDuration || value;

  if (!duration) {
    return "";
  }

  return <span className="text-sm text-gray-700">{duration}</span>;
}

export default RouteDurationCell;
